let { monkey } = require('baobab');
let _ = require('lodash');
let { dfsRecursive, getLeafs } = require('../../../helpers/tree');

function selectOptionalExportColumns (columns) {
    return _.filter(columns, (x) => x.isBasic == false);
}

function selectBasicExportColumns (columns) {
    return _.filter(columns, (x) => x.isBasic === true);
}

module.exports = {
    setCitiesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'cities', 'tree'],
            ['order', 'originalParameters', 'cities']
        );
    },

    setBranchesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'branches', 'tree'],
            ['order', 'originalParameters', 'branches']
        );
    },

    setRubricsComputes (state) {
        setTreeComputes(
            state,
            ['order', 'rubrics', 'tree'],
            ['order', 'originalParameters', 'rubrics']
        );
        boolFilterRussianByCities(state, ['order', 'rubrics', 'tree']);
    },

    setLegalEntitiesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'addParams', 'legalEntities', 'tree'],
            ['order', 'originalParameters', 'legalEntities']
        );
        boolFilterRussianByCities(state, ['order', 'addParams', 'legalEntities', 'tree']);
    },

    setPurposesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'addParams', 'purposes', 'tree'],
            ['order', 'originalParameters', 'purposes']
        );
        boolFilterRussianByCities(state, ['order', 'addParams', 'purposes', 'tree']);
    },

    setMapClassesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'addParams', 'mapClasses', 'tree'],
            ['order', 'originalParameters', 'mapClasses']
        );
    },

    setPaymentTypesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'addParams', 'paymentTypes', 'tree'],
            ['order', 'originalParameters', 'paymentTypes']
        );
        boolFilterRussianByCities(state, ['order', 'addParams', 'paymentTypes', 'tree']);
    },

    setNumberOfEmployeesComputes (state) {
        setTreeComputes(
            state,
            ['order', 'addParams', 'numberOfEmployees', 'tree'],
            ['order', 'originalParameters', 'numberOfEmployees']
        );
    },

    setStatisticComputes (state) {
        setStatisticTreeComputes(
            state,
            ['order', 'statistic', 'tree'],
            ['order', 'originalParameters', 'statistic']
        );
    },

    /**
     * Рассчитываем состояниие подсказки "Данные заказа изменились"
     * @param {Object} state
     */
    computeDataChangeTooltipState (state) {
        state.set(['order', 'computed', 'showDataChangeTooltip'], monkey(
            ['order', 'localStorageSelectedParamsWasOutdated'],
            ['order', 'draft', 'isNeedToConfirmDataChanged'],
            ['order', 'tooltip', 'hideDataChangeTooltip'],
            ['page', 'name'],
            (localStorageSelectedParamsWasOutdated = false, isNeedToConfirmDataChanged = false,
             hideDataChangeTooltip = false, pageName = '') => {
                // показываем подсказку только на главной странице, на странице "Заказы" есть своя логика
                if (pageName != 'order') {
                    return false;
                }
                if (hideDataChangeTooltip) {
                    return false;
                } else if (localStorageSelectedParamsWasOutdated || isNeedToConfirmDataChanged) {
                    return true;
                }
                return false;
            }
        ));
    },

    computeIsExportColumnChecked (state, propertyName) {
        state.set(['order', 'computed', 'exportColumns', 'byPropertyName', propertyName, 'isChecked'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            ['order', 'addParams', 'exportColumns'],
            (columns = [], addParams = {}) => {
                let column = _.find(columns, { propertyName: propertyName });
                if (column) {
                    if (addParams.hasOwnProperty(column.id)) {
                        return addParams[column.id].isChecked;
                    }
                }
                return false;
            }
        ));
    },

    /**
     * Считаем нужно ли показывать коллапсер с рубриками
     * @param {Object} state
     */
    computeRubricsState (state) {
        state.set(['order', 'computed', 'hideRubrics'], monkey(
            ['order', 'typeId'],
            (typeId) => typeId && typeId === 3
        ));
    },

    /**
     * Заполняем данные по выгружаемым колонкам
     * @param {Object} state
     */
    formatExportColumnsBasic (state) {
        state.set(['order', 'computed', 'exportColumns', 'basic', 'view'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            (original = []) => {
                let result = {};
                _.forEach(selectBasicExportColumns(original), (x) => {
                    result[x.id] = x;
                });
                return result;
            }
        ));
    },

    /**
     * Вычисляем порядок следование базовых колонок
     * @param {Object} state
     */
    formatExportColumnsBasicOrder (state) {
        state.set(['order', 'computed', 'exportColumns', 'basic', 'viewOrder'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            (original = []) => {
                let result = [];
                _.forEach(selectBasicExportColumns(original), (x) => {
                    result.push({ id: x.id, name: x.name, propertyName: x.propertyName });
                });
                return result;
            }
        ));
    },

    /**
     * Вычисляем порядок следование базовых колонок
     * @param {Object} state
     */
    setExportColumnAlwaysTrueForBasicColumnsCheckbox (state) {
        state.set(['order', 'computed', 'exportColumns', 'basic', 'alwaysTrue'], monkey(
            () => true
        ));
    },

    /**
     * Вычисляем порядок следование опциональных колонок
     * @param {Object} state
     */
    formatExportColumnsOptionalOrder (state) {
        state.set(['order', 'computed', 'exportColumns', 'optional', 'viewOrder'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            (original = []) => {
                let result = [];
                _.forEach(selectOptionalExportColumns(original), (x) => {
                    result.push({ id: x.id, name: x.name, propertyName: x.propertyName });
                });
                return result;
            }
        ));
    },

    /**
     * Заполняем данные по выгружаемым колонкам
     * @param {Object} state
     */
    formatExportColumnsOptional (state) {
        state.set(['order', 'computed', 'exportColumns', 'optional', 'view'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            (original = []) => {
                let result = {};
                _.forEach(selectOptionalExportColumns(original), (x) => {
                    result[x.id] = _.clone(x);
                });
                return result;
            }
        ));
    },

    /**
     * Заполняем данные по выгружаемым колонкам
     * @param {Object} state
     */
    calculateOptionalExportColumnsValue (state) {
        state.set(['order', 'computed', 'exportColumns', 'optional', 'value'], monkey(
            ['order', 'price', 'data', 'byColumns'],
            (price = []) => {
                let result = {};
                _.forEach(price, (value, key) => {
                    let column = {
                        IsChecked: true,
                        rowPrice: value.rowPrice,
                        rowAmount: value.rowAmount
                    };
                    if (value.discountPercentage > 0) {
                        column.discountPercentage = value.discountPercentage;
                        column.rowPriceWithoutDiscount = value.rowPriceWithoutDiscount;
                    }
                    let columnId = parseInt(key, 10);
                    result[columnId] = column;
                });

                return result;
            }
        ));
    },

    /**
     * Узнаём выбрана ли колонка выгркузи "ИНН"
     * @param {Object} state
     */
    isShowGreeder (state) {
        state.set(['order', 'computed', 'isShowGreeder'], monkey(
            ['order', 'originalParameters', 'exportColumns', 'columns'],
            ['order', 'addParams', 'exportColumns'],
            ['order', 'typeId'],
            (columns = [], selected = {}, orderType = 0) => {
                if (orderType !== 2) {
                    return false;
                }
                let innColumn = _.find(columns, { propertyName: 'Inn' });
                if (innColumn && selected[innColumn.id]) {
                    return selected[innColumn.id].isChecked;
                }
                return false;
            }
        ));
    },

    isGosResSourceSelected (state) {
        state.set(['order', 'computed', 'isGosResSourceSelected'], monkey(
            ['order', 'addParams', 'greederColumns', 'source', 'egrip', 'isChecked'],
            ['order', 'addParams', 'greederColumns', 'source', 'egrul', 'isChecked'],
            (isEgrip = false, isEgrul = false) => isEgrip || isEgrul
        ));
    },

    isOfflineOrder (state) {
        state.set(['order', 'computed', 'isOfflineOrder'], monkey(
            ['order', 'typeId'],
            (typeId = 0) => typeId > 1
        ));
    },

    /**
     * Преобразуем список распознанных рубрик в строку, которую можно вставить в input типа textarea
     * @param state
     */
    computeRubricsRecognizedInputValue (state) {
        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'recognized'], monkey(
            ['order', 'treeUpload', 'rubrics', 'recognized'],
            (recognizedRubrics = []) => _.map(recognizedRubrics, 'name').join('\n')
        ));
    },


    /**
     * Преобразуем список нераспознанных рубрик в строку, которую можно вставить в input типа textarea
     * @param state
     */
    computeRubricsUnrecognizedInputValue (state) {
        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'unrecognized'], monkey(
            ['order', 'treeUpload', 'rubrics', 'unrecognized'],
            (unrecognizedRubrics = []) => unrecognizedRubrics.join('\n')
        ));
    },

    computeIsAnyUnrecognizedRubrics (state) {
        state.set(['order', 'computed', 'treeUpload', 'rubrics', 'haveUnrecognized'], monkey(
            ['order', 'treeUpload', 'rubrics', 'unrecognized'],
            (unrecognizedRubrics = []) =>
                unrecognizedRubrics && unrecognizedRubrics.length > 0
        ));
    },

    /**
     * Преобразуем список распознанных рубрик в строку, которую можно вставить в input типа textarea
     * @param state
     */
    computeCitiesRecognizedInputValue (state) {
        state.set(['order', 'computed', 'treeUpload', 'cities', 'recognized'], monkey(
            ['order', 'treeUpload', 'cities', 'recognized'],
            (recognized = []) => _.map(recognized, 'name').join('\n')
        ));
    },


    computeCitiesUnrecognizedInputValue (state) {
        state.set(['order', 'computed', 'treeUpload', 'cities', 'unrecognized'], monkey(
            ['order', 'treeUpload', 'cities', 'unrecognized'],
            (unrecognized = []) => unrecognized.join('\n')
        ));
    },

    computeIsAnyUnrecognizedCities (state) {
        state.set(['order', 'computed', 'treeUpload', 'cities', 'haveUnrecognized'], monkey(
            ['order', 'treeUpload', 'cities', 'unrecognized'],
            (unrecognized = []) =>
                unrecognized && unrecognized.length > 0
        ));
    }
};

function showDescendantsCount (state, basePath) {
    state.set(basePath.concat('computed', 'showDescendantsCount'),
        monkey(['account', 'orders', 'computed', 'currentOrder', 'isEditable'],
            (isEditable = true) => isEditable));
}

function setTreeComputes (state, basePath, srcDataPath) {
    filteredItems(state, basePath, srcDataPath);
    autoExpand(state, basePath);
    computeShowSelectedOnly(state, basePath);
    leafs(state, basePath, srcDataPath);
    descendantLeafsCount(state, basePath, srcDataPath);
    showDescendantsCount(state, basePath);
    selectedDescendantLeafsCount(state, basePath, srcDataPath);
}

function setStatisticTreeComputes (state, basePath, srcDataPath) {
    filteredItems(state, basePath, srcDataPath);
}

function descendantLeafsCount (state, basePath, srcDataPath) {
    state.set(basePath.concat('computed', 'descendantLeafsCount'),
        monkey(
            srcDataPath,
            (original) => {
                if (!original) {
                    return {};
                }
                let out = {};
                dfsRecursive(original, '0', (node) => {
                    let children = node.children || [];
                    if (children.length === 0) {
                        out[node.code] = 1;
                    } else {
                        out[node.code] = _.sumBy(children, (x) => out[x]);
                    }
                });
                return out;
            }
        ));
}

function selectedDescendantLeafsCount (state, basePath, srcDataPath) {
    state.set(basePath.concat('computed', 'selectedDescendantLeafsCount'),
        monkey(
            srcDataPath,
            basePath.concat('selected'),
            (original, selected) => {
                if (!original) {
                    return {};
                }
                let out = {};
                dfsRecursive(original, '0', (node) => {
                    let children = node.children || [];
                    if (children.length === 0) {
                        if (_.get(selected, [node.code, 'value'], false)) {
                            out[node.code] = 1;
                        } else {
                            out[node.code] = 0;
                        }
                    } else {
                        out[node.code] = _.sumBy(children, (x) => out[x]);
                    }
                });
                return out;
            }
        ));
}

function filteredItems (state, basePath, srcDataPath) {
    state.set(basePath.concat('computed', 'items'),
        monkey(
            srcDataPath,
            basePath.concat('filter'),
            basePath.concat('boolFilters'),
            ['order', 'isDisabled'],
            ['order', 'typeId'],
            (original, filter, boolFilters, isDisabled = false, typeId = 1) => {
                if (!original) {
                    return {};
                }
                let result = original;
                if (boolFilters && !isDisabled && typeId !== 1) {
                    Object.keys(boolFilters).forEach(function(key) {
                        if(boolFilters[key] === undefined){
                            return; // если значение фильтра не задано, то не фильтруем
                        }
                        let selector = (x) => x[key] === boolFilters[key];
                        let out = {};
                        dfsRecursive(result, '0', (node) => filterNodeBySelector(node, selector, out));
                        result = out;
                    })
                }

                if (filter) {
                    let out = {};
                    dfsRecursive(result, '0', (node) => filterNode(node, filter, out));
                    result = out;
                }
                return result;
            }
        ));
}

function boolFilterRussianByCities (state, basePath) {
    state.set(basePath.concat(['boolFilters', 'isRussian']),
        monkey(
            ['order', 'cities', 'tree', 'hasRussians'],
            ['order', 'cities', 'tree', 'hasNonRussians'],
            (hasRussians = false, hasNonRussians = false) => {
                if(hasRussians === true && hasNonRussians === false) {
                    return true;
                }
                return undefined;
            }
        ));
    state.set(basePath.concat(['boolFilters', 'isNonRussian']),
        monkey(
            ['order', 'cities', 'tree', 'hasRussians'],
            ['order', 'cities', 'tree', 'hasNonRussians'],
            (hasRussians = false, hasNonRussians = false) => {
                if(hasNonRussians === true && hasRussians === false) {
                    return true;
                }
                return undefined;
            }
        ));
}

function autoExpand (state, basePath) {
    state.set(basePath.concat('computed', 'autoExpand'),
        monkey(
            basePath.concat('filter'),
            // showBranchTree относится только к дереву городов, но для простоты пока одна функция autoExpand для всех
            basePath.concat('showBranchTree'),
            (filter, showBranchTree) => filter !== null || showBranchTree
        ));
}

function computeShowSelectedOnly (state, basePath) {
    state.set(basePath.concat('computed', 'showSelectedOnly'),
        monkey(
            ['order', 'isDisabled'],
            basePath.concat('showSelectedOnly'),
            (isDisabled = false, showSelectedOnly = false) => isDisabled || showSelectedOnly
        ));
}

function leafs (state, basePath, srcDataPath) {
    state.set(basePath.concat('computed', 'leafs'),
        monkey(
            srcDataPath,
            (original) => getLeafs(original)
        ));
}

function filterNode (node, filter, out) {
    let children = node.children || [];

    let labelMatched = node.label && matches(node.label, filter);
    let root = node.parentCode === null;

    let filteredChildren = _.filter(children, (x) => _.has(out, x));

    if (root || filteredChildren.length > 0 || labelMatched) {
        out[node.code] = {
            label: node.label,
            code: node.code,
            parentCode: node.parentCode,
            branchId: node.branchId,
            isDefaultCity: node.isDefaultCity,
            branchLink: node.branchLink,
            branchName: node.branchName,
            isBranchTreeRelated: node.isBranchTreeRelated,
            children: filteredChildren
        };
    }
}

function filterNodeBySelector (node, selector, out) {
    let children = node.children || [];
    let root = node.parentCode === null;

    let filteredChildren = _.filter(children, (x) => _.has(out, x));

    if (root || filteredChildren.length > 0 || selector(node) === true) {
        out[node.code] = {
            label: node.label,
            code: node.code,
            parentCode: node.parentCode,
            branchId: node.branchId,
            isDefaultCity: node.isDefaultCity,
            branchLink: node.branchLink,
            branchName: node.branchName,
            isBranchTreeRelated: node.isBranchTreeRelated,
            children: filteredChildren
        };
    }
}

function matches (value, filter) {
    if (filter) {
        return value.toLocaleLowerCase().indexOf(filter.toLocaleLowerCase()) > -1;
    }
    return true;
}



// WEBPACK FOOTER //
// ./actions/computed/order/index.js